import { HANDLE_ERROR } from '../action.type';
const intialState = {
  error: null
};

export const errorReducer = (state = intialState, action) => {
  switch (action.type) {
    case HANDLE_ERROR:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state;
  }
};
